import React from "react";
import Button from "react-bootstrap/Button";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

type Props = {
  setShowDownsellModal: (show: boolean) => void;
  buttonText?: string;
  isCancelled?: boolean;
};

const DownsellModal: React.FC<Props> = ({
  setShowDownsellModal,
  buttonText = "50% Off Next Rebill",
  isCancelled,
}) => {
  const buttonClassName = "font-size-sm font-weight-semibold primary-button";

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      The downsell can not be applied on canceled subscriptions
    </Tooltip>
  );

  return (
    <>
      {isCancelled ? (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <Button
            variant="outline-secondary"
            className={`${buttonClassName} cursor-not-allowed`}
            disabled
          >
            {buttonText}
          </Button>
        </OverlayTrigger>
      ) : (
        <Button
          variant="btn btn-primary"
          className={buttonClassName}
          onClick={() => setShowDownsellModal(true)}
        >
          {buttonText}
        </Button>
      )}
    </>
  );
};

export default DownsellModal;
